import { takeEvery, call, put, select } from 'redux-saga/effects';
import { setStates, setSuppliers, fetchError, setChartsData } from '../actions';
import { FETCH_STATES, FETCH_SUPPLIERS, SET_SELECTED_STATE, FETCH_CHARTSDATA } from '../types';
import { fetchStatesApi, fetchUtilitiesApi, fetchLoadZonesApi, fetchRateClassesApi, fetchPriceTrendChartData, fetchPriceTrendMinMaxChartData, fetchForwardCurveChartData, fetchForwadCurveMinMaxChartData } from '../../api';
import {RateClassifications} from '../../const/index'
import { STATIC_RANKINGS_DELTA_BEST_RAW } from '../../const/nonPremiumStaticRankingsData';

function* fetchAndDispatchChart(apiFn, chartType, params) {
  try {
    const response = yield call(apiFn, params);
    yield put(setChartsData(response, chartType));
  } catch (error) {
    console.error(`Error fetching ${chartType}:`, error);
  }
}

function* fetchChartsData(action: any) {
  try {
    const {clientId, userToken, isPremium} = action.payload || {};
    const commodity = yield select((state) => state.ranking.commodity);
    // const states = yield select((state) => state.pricing.states);
    let MarketEnerexIdentifier=yield select((state) => state.ranking.selectedMarket.value);
    MarketEnerexIdentifier = commodity === 2 ? null : MarketEnerexIdentifier;
    const effectiveFromDate = yield select((state) => state.ranking.effectiveFromDate);
    const effectiveToDate = null;
    // yield select((state) => state.ranking.effectiveToDate);
    // const selectedState = yield select(s => s.ranking.selectedState?.name);
    const terms = yield select((state) => state.ranking.terms);
    const selectedTerm = terms.find((state: any) => state?.isSelected)?.value;
    const productType = yield select((state) => state.ranking.productTypes);
    const selectedLoadProfile   = yield select(s => s.ranking.selectedLoadProfile?.value);

    // const selectedproductType = productType.find((state: any) => state?.isSelected)?.value;

  const selectedProductType =
  productType
    ?.filter((state: any) => state?.isSelected)
    ?.map((state: any) => state.value) || [];
    const selectedStateName = yield select(s => s.ranking.selectedState?.name);
    const statesList = yield select((state) => state.ranking.states);
    const isAllSelected = selectedStateName === 'All' || !selectedStateName;
    const selectedStatesArray = isAllSelected?[]
      // ? (statesList || [])
      //     .filter((s: any) => s && s.name && s.name !== 'All')
      //     .map((s: any) => s.name)
      : [selectedStateName];

      const costComponent = yield select((state) => state.ranking.costComponents);
    // const selectedProductType = ProductType.find((state: any) => state?.isSelected)?.value;
    const rawSelectedPassThrough =
  costComponent
    ?.filter((state: any) => state?.isSelected)
    ?.map((state: any) => state.value) || [];
      const hasAllSelected = rawSelectedPassThrough.includes("All");
      const passThroughValues = hasAllSelected
        ? []
        : rawSelectedPassThrough.filter((value: any) => value !== "All");


    //dependant dropdowns values
    const selectedUtility       = yield select(s => s.ranking.selectedUtility?.value);
    const selectedRateClass     = yield select(
      (s) => 
        s.ranking.selectedRateClass?.name 
    );
    const selectedLoadZone      = yield select(s => s.ranking.selectedLoadZone?.name);
    const selectedBillingMethod = yield select(s => s.ranking.selectedBillingMethod?.name);
    const customerClass = yield select((s) => s.ranking.customerClass);
    const usage = yield select(s => s.ranking.usage);
    const demand = yield select(s => s.ranking.demand);
    const loadFactor = yield select(s => s.ranking.loadFactor);
    const taxIncluded = yield select(s => s.ranking.taxIncluded);
    const por = yield select(s => s.ranking.por);
    const startToDate = yield select(s => s.ranking.startToDate);

    if (!userToken) {
      console.warn('Missing user token for rankings chart request');
      return;
    }

    if (isPremium === false) {
      yield put(setChartsData(STATIC_RANKINGS_DELTA_BEST_RAW, 'priceTrend', false));
      return;
    }

    const params = {userToken, commodity, selectedState:selectedStatesArray, selectedTerm, effectiveFromDate, effectiveToDate, 
      selectedUtility,selectedRateClass, selectedLoadZone, selectedBillingMethod, usage, demand, loadFactor,clientId,selectedProductType,selectedLoadProfile,passThrough: passThroughValues, MarketEnerexIdentifier, startToDate, customerClass, taxIncluded, por};

    yield call(fetchAndDispatchChart, fetchPriceTrendChartData, 'priceTrend', {...params, chartFlags: ['DeltaBest']});
    // yield call(fetchAndDispatchChart, fetchPriceTrendChartData, 'priceTrendMinMax', {...params, chartFlags: ['DeltaWorst']});
    // yield call(fetchAndDispatchChart, fetchPriceTrendChartData, 'forwardCurve', {...params, chartFlags: ['DeltaNextBest']});
    // yield call(fetchAndDispatchChart, fetchPriceTrendChartData, 'forwardCurveMinMax', {...params, chartFlags: ['DeltaNextWorst']});

  } catch (error) {
    yield put(fetchError('Failed to fetch chart data'));
  }
}


// function* fetchUtilitiesSaga(action: any) {
//   try {
//     const { state, commodity } = action.payload;
// yield put({ type: FETCH_CHARTSDATA, payload: {clientId} });
//     const token = yield select((state) => state.pricing.ECToken?.token);
//     const params = {
//       state,
//       commodity,
//       token
//     }
//     // Pass commodity through to your API client:
//     const list  = yield call(
//       fetchUtilitiesApi,
//       params
//     );
//     yield put(setUtilities(list));
//   } catch (err) {
//     yield put(fetchError('Failed to fetch utilities'));
//   }
// }

export function* watchPricingActions() {
//   yield takeEvery(FETCH_STATES, fetchStatesSaga);
//   yield takeEvery(FETCH_STATES, fetchStatesSaga);
//   yield takeEvery(SET_SELECTED_STATE, fetchLoadZonesSaga);
  yield takeEvery(FETCH_CHARTSDATA, fetchChartsData);
  // yield takeEvery(FETCH_UTILITIES, fetchUtilitiesSaga);
//   yield takeEvery(FETCH_SUPPLIERS, fetchSuppliersSaga);
//   yield takeEvery(FETCH_RATE_CLASSES, fetchRateClassesSaga);
}

// TODO: either remove or use these saga as per future requirements

// function* fetchSuppliersSaga(action: any) {
//   try {
//     const response = yield call(fetchSuppliersApi, action.payload);
//     yield put(setSuppliers(response));
//   } catch (error) {
//     yield put(fetchError('Failed to fetch suppliers'));
//   }
// }

// function* fetchRateClassesSaga(action: any) {
//   try {
//     const response = yield call(fetchRateClassesApi, action.payload);
//     yield put(setRateClasses(response));
//   } catch (error) {
//     yield put(fetchError('Failed to fetch rate classes'));
//   }
// }

// function* fetchStatesSaga() {
//   try {
//     const response = yield call(fetchStatesApi);
//     yield put(setStates(response));
//   } catch (error) {
//     yield put(fetchError('Failed to fetch states'));
//   }
// }

// function* fetchRateClassesSaga() {
//     try {
//       const rateClasesList = RateClassifications.map((rateClass) => { return {...rateClass, isSelected: false}});
//       yield put(setRateClasses(rateClasesList));
//     } catch (error) {
//       yield put(fetchError('Failed to fetch states'));
//     }
//   }

// function* fetchUtilitiesSaga(action: any) {
//   try {
//     const response = yield call(fetchUtilitiesApi, action.payload);
//     yield put(setUtilities(response));
//   } catch (error) {
//     yield put(fetchError('Failed to fetch utilities'));
//   }
// }

// function* fetchLoadZonesSaga(action: any) {
//   try {
//     const response = yield call(fetchLoadZonesApi, action.payload);
//     yield put(setLoadZones(response));
//   } catch (error) {
//     yield put(fetchError('Failed to fetch load zones'));
//   }
// }
